import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.lead,
  errorColor: colors.warningRed
};
export default book;